import { useEffect, useMemo } from "react";
import * as L from "leaflet";

import { EmissionType } from "src/types";
import { getEmissionWMSLayerName } from "src/utils/emission.utils";
import { useEmission } from "src/hooks";
import { getWFSGetFeature } from "src/services/ogc.service";
import { useQuery } from "react-query";
import { getLeafletMarker } from "src/hooks/useDrawMarker";
import { Z_INDEX } from "src/config/zIndex";

interface Props {
  map: L.Map;
  scenarioId: string | number;
  emissionId: string | number;
  pointSourceId: string | number;
}
export function PointSourceOnMap(props: Props) {
  const { map, scenarioId, emissionId, pointSourceId } = props;
  const { data: emission } = useEmission(scenarioId, emissionId, EmissionType.POINT_SOURCE);
  const paneKey = "active-point-source";
  useEffect(() => {
    // add the active-segment pane when not present
    // the pane controls the zIndex
    const pane = map.getPane(paneKey);

    if (!pane) map.createPane(paneKey);
    map.getPane(paneKey)!.style.zIndex = Z_INDEX.activePointSource.toString();
  }, [map]);

  const { data: wmsFeatureInfo } = useQuery(
    ["emission-feature-info", emission?.id],
    () =>
      getWFSGetFeature({
        typeNames: getEmissionWMSLayerName(EmissionType.POINT_SOURCE),
        cql_filter: `shape_id=${pointSourceId}`,
        viewParams: `shapecollection_id:${emission?.geoserverFilter}`,
      }),
    { enabled: !!emission }
  );

  const featureLayers = useMemo(() => {
    if (!wmsFeatureInfo) return [];
    if (!wmsFeatureInfo.features) return [];

    return wmsFeatureInfo.features.map((feature) => {
      const featureLayer = L.geoJSON(feature.geometry, {
        pointToLayer: (_, latlng) =>
          getLeafletMarker(latlng, "active", {
            pane: paneKey,
          }),
      });

      return featureLayer;
    });
  }, [wmsFeatureInfo]);

  useEffect(() => {
    if (!map) return;

    featureLayers.forEach((layer) => {
      map.addLayer(layer);
    });

    return function cleanup() {
      featureLayers.forEach((layer) => map.removeLayer(layer));
    };
  }, [map, featureLayers]);

  return render();
  function render() {
    return null;
  }
}
